export const SESSION_KEYS = {
    LIST_INSTITUTIONS: 'list-institutions',
    CURRENT_INSTITUTION: 'current-institution'
}
